/**
 * `onDidPresent` handler for an inline overlay (IonLoading and friends) whose
 * `isOpen` can go false moments after it went true.
 *
 * An inline overlay that loads already open presents on the next animation
 * frame, and a dismiss that arrives before that present runs is a no-op
 * because nothing has been presented yet. So when `isOpen` flips back to false
 * in that gap the overlay presents anyway and stays up for good, its backdrop
 * covering the app. The app-wide database spinner hits this whenever the
 * database opens within a frame or so of the spinner mounting.
 *
 * Once the overlay has presented, dismiss it again if it is no longer meant to
 * be open.
 */
export const dismissIfPresentedWhileClosed = (event: CustomEvent) => {
    const overlay = event.target as HTMLIonLoadingElement | null;
    if (!overlay || overlay.isOpen !== false) {
        return;
    }
    overlay.dismiss().catch((err) => {
        console.warn("Dismissing an overlay that presented late failed", err);
    });
};
